import { default as theme } from './theme';
import { breakpointsVariants, mqMax, mqMin, BreakpointsVariantsType, BREAKPOINT } from './breakpoints';
import { colorVariants } from '../utils';
import { componentVariants, Components } from './components';
import { fontSizeVariants, FontSizeVariantsType } from './font-sizes';
import { typographyVariants, TypographyVariantsType } from './typography';
import { radiiVariants, RadiiVariantsType } from './radii';
import { shadowsVariants, ShadowsVariantsType } from './shadows';
import { spaceVariants, SpaceVariantsType } from './space';
import { zIndicesVariants, ZIndicesVariantsType } from './z-indices';

// variant keys
export const variants = {
  ...componentVariants,
  breakpoints: breakpointsVariants,
  colors: colorVariants,
  fontSize: fontSizeVariants,
  typography: typographyVariants,
  radii: radiiVariants,
  shadows: shadowsVariants,
  sapce: spaceVariants,
  zIndices: zIndicesVariants,
};

export interface ComponentType extends Components {
  /** The theme Breakpoints types. */
  Breakpoints: BreakpointsVariantsType;
  /** The theme FontSize types. */
  FontSize: FontSizeVariantsType;
  /** The theme Radii types. */
  Radii: RadiiVariantsType;
  /** The theme Shadows types. */
  Shadows: ShadowsVariantsType;
  /** The theme Space types. */
  Space: SpaceVariantsType;
  /** The theme Typography types. */
  Typography: TypographyVariantsType;
  /** The theme ZIndices types. */
  ZIndices: ZIndicesVariantsType;
}

// theme specifics
export { mqMin, mqMax, BREAKPOINT };

export { theme };

export default theme;
